import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { fetchDeliveryLocations } from '../../../../actions/deliveryLocation/deliveryLocationList'
import { AppState } from '../../../../reducers'
import { DeliveryLocationListState } from '../../../../reducers/deliveryLocation/deliveryLocationList'
import { SessionState } from '../../../../reducers/auth/session'
import { roleToURLPrefix } from '../../../../App'
import { PERSON } from '../../../../models/User'
import { Box, Button, CircularProgress, Stack } from '@mui/material'
import DeliveryLocations from '..'
import DeliveryLocation, { commonChacoDeliveryLocation, commonDeliveryLocation } from '../../../../models/DeliveryLocation'
import { AddHomeWorkOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { AddDeliveryLocationDialog } from '../AddDeliveryLocation'
import { ProvinceListState } from '../../../../reducers/province/provinceList'
import { fetchProvinces } from '../../../../actions/deliveryLocation/provinceList'
import { fetchPrepayment } from '../../../../actions/prepayment/prepaymentDetail'
import { PrepaymentDetailState } from '../../../../reducers/prepayment/prepaymentDetail'

interface Props {
  deliveryLocationList: DeliveryLocationListState
  provinceList: ProvinceListState
  prepaymentDetail: PrepaymentDetailState
  session: SessionState
}


const DeliveryLocationList: React.FC<Props> = ({ deliveryLocationList, provinceList, prepaymentDetail, session }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation('delivery')
  const [reading, setReading] = useState<boolean>(true)
  const [showAddDeliveryLocationDialog, setShowAddDeliveryLocationDialog] = useState<boolean>(false)
  const params = useParams<{ prepaymentId: string }>()

  useEffect(() => {
    dispatch(fetchDeliveryLocations(history.location.search))
    dispatch(fetchProvinces('?all=true'))
    if( params.prepaymentId )
      dispatch(fetchPrepayment(params.prepaymentId))
    setReading(false)
// eslint-disable-next-line     
  }, [dispatch, history.location.search])


  useEffect(() => {
    if( params.prepaymentId )
      {
      dispatch(fetchPrepayment(params.prepaymentId))
      }
  }, [dispatch, params])



  const confirmDeliveryLocation = (deliveryLocation: DeliveryLocation) => {
    setShowAddDeliveryLocationDialog(false)
    linkToPreorderWithPrepayment(deliveryLocation)
  }

  const linkToPreorderWithPrepayment = (deliveryLocation: DeliveryLocation) => {
    setReading(false)
    const dlJSON = JSON.stringify(deliveryLocation)
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/preorders/main`
    history.push(detailUrl, { delivery: dlJSON, prepaymentId: params.prepaymentId })
  }

  return (
    <>
      {!reading && !deliveryLocationList.isFetching &&
        <Stack> 
          <DeliveryLocations
              // en chaco SOLO retira en planta chaco
              rows={(!session.isChaco ? [...deliveryLocationList.deliveryLocations || [], commonDeliveryLocation] : [commonChacoDeliveryLocation]
               //jurisdiccion en prepayment / acopio
                ).filter(value => !params.prepaymentId ||
                (prepaymentDetail && prepaymentDetail.prepayment && prepaymentDetail.prepayment.length > 0 &&
                  prepaymentDetail.prepayment[0].codigo_provincia &&
                  ((prepaymentDetail.prepayment[0].codigo_provincia > 0 && prepaymentDetail.prepayment[0].codigo_provincia <= 2 && value.codigo_provincia <= 2) || 
                value.codigo_provincia === prepaymentDetail.prepayment[0].codigo_provincia ) )).map(s => ({ data: s }))}
            loading={deliveryLocationList.isFetching}
            provinceList={provinceList}
            pagination={deliveryLocationList.pagination || undefined}
            onClickInfo={linkToPreorderWithPrepayment}
          />
          {session.allowAddDeliveryLocation &&
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Button variant="contained" sx={{ textTransform: "none", margin: "10px" }}
               startIcon={<AddHomeWorkOutlined />} onClick={(e) => { e.stopPropagation(); setShowAddDeliveryLocationDialog(true) }}>{t("addDeliveryLocation")}</Button>
          </Box>}
          {showAddDeliveryLocationDialog &&
            <AddDeliveryLocationDialog
              provinceList={provinceList}
              provinceCode={!params.prepaymentId ? undefined : 
                 prepaymentDetail && prepaymentDetail.prepayment && prepaymentDetail.prepayment.length > 0 ? prepaymentDetail.prepayment[0].codigo_provincia : undefined}
              onConfirm={confirmDeliveryLocation}
              onCancel={() => setShowAddDeliveryLocationDialog(false)} />}
        </Stack>
      }
      {(reading || deliveryLocationList.isFetching) &&
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={25} />
        </div>
      }
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  deliveryLocationList: state.deliveryLocationList,
  provinceList: state.provinceList,
  prepaymentDetail: state.prepaymentDetail,
  session: state.session
})

export default connect(mapStateToProps, null)(DeliveryLocationList)